import { Link, useParams } from "react-router-dom";
import { api } from "../api";
import { useResource } from "../resources";
import TxRow from "../components/TxRow";
import RecordStatus from "../components/RecordStatus";

export default function RoundPage() {
  const { n } = useParams<{ n: string }>();
  const round = n == null ? NaN : Number(n);
  const resource = useResource(Number.isInteger(round) && round >= 0 ? round : undefined, api.round);
  const data = resource.data;
  const status = <RecordStatus resource={resource} />;
  if (!data) return status;
  const { witnesses, txs } = data;
  const counts = txs.reduce<Record<string, number>>((counts, tx) => {
    counts[tx.status] = (counts[tx.status] ?? 0) + 1;
    return counts;
  }, {});

  return (
    <div className="space-y-5">
      {status}
      <h1 className="text-xl font-bold text-mesh-accent">round {n}</h1>
      <section className="bg-mesh-panel/40 rounded-lg p-4">
        <h2 className="text-sm uppercase tracking-wider text-mesh-mute mb-3">
          witnesses ({witnesses.length})
        </h2>
        {witnesses.length === 0 ? (
          <div className="text-mesh-mute text-sm py-4 text-center">
            no witness for this round yet
          </div>
        ) : (
          <div className="space-y-3">
            {witnesses.map((w) => {
              const tips = w.tips_json == null ? null : JSON.parse(w.tips_json) as string[];
              const included = w.included_tx_ids_json == null ? null : JSON.parse(w.included_tx_ids_json) as string[];
              return (
                <div key={w.tx_id} className="bg-mesh-bg rounded p-3 text-sm">
                  <Link to={`/tx/${w.tx_id}`} className="block hex break-all text-mesh-accent hover:underline">{w.tx_id}</Link>
                  {w.phys_time == null && <p className="text-xs text-mesh-mute">Witness transaction indexed; snapshot details not indexed.</p>}
                  <dl className="grid grid-cols-2 gap-2 mt-2">
                    {[
                      ["witness pubkey", w.witness_pubkey],
                      ["phys_time", w.phys_time == null ? null : new Date(w.phys_time * 1000).toLocaleString()],
                      ["prev_witness", w.prev_witness],
                      ["tips", tips?.length],
                      ["included txs", included?.length],
                      ["vrf_output", w.vrf_output],
                    ].map(([label, value]) => <div key={label} className="min-w-0">
                      <dt className="text-xs text-mesh-mute">{label}</dt>
                      <dd className="break-all">{value == null ? "not indexed" : value}</dd>
                    </div>)}
                  </dl>
                </div>
              );
            })}
          </div>
        )}
      </section>
      <section className="bg-mesh-panel/40 rounded-lg p-4">
        <h2 className="text-sm uppercase tracking-wider text-mesh-mute mb-3">
          transactions ({txs.length})
        </h2>
        {txs.length > 0 && <p className="text-xs text-mesh-mute mb-3">
          {Object.entries(counts).map(([status, count]) => `${count} ${status}`).join(" · ")}
        </p>}
        {txs.length === 0 ? (
          <div className="text-mesh-mute text-sm py-4 text-center">
            none
          </div>
        ) : (
          txs.map((t) => <TxRow key={t.tx_id} tx={t} />)
        )}
      </section>
    </div>
  );
}
